import React from "react";

const PortfolioIcon = () => {
  return (
    <div className="portfolioIcon">
      <div className="mx-auto max-w-screen-xl">
        <div className="content">
          <div className="title mb-8">
            <h3>Lorem ipsum</h3>
          </div>
          <div className="item flex justify-between">
            <div className="subItem">
              <div className="subItemContent">
                <img src={"./img/Group_682.png"} alt="Group_682.png" />
                <h4>Lorem ipsum</h4>
                <p>
                  Lorem ipsum dolor ngồi amet consectetuer lorem ipsum dolor
                  ngồi amet consectetuer lorem ipsum dolor ngồi amet
                  consectetuer lorem ipsum dolor ngồi amet consectetuer lorem
                  ipsum dolor{" "}
                </p>
              </div>
            </div>
            <div className="subItem">
              <div className="subItemContent">
                <img src={"./img/Group_682.png"} alt="Group_682.png" />
                <h4>Lorem ipsum</h4>
                <p>
                  Lorem ipsum dolor ngồi amet consectetuer lorem ipsum dolor
                  ngồi amet consectetuer lorem ipsum dolor ngồi amet
                  consectetuer lorem ipsum dolor ngồi amet consectetuer lorem
                  ipsum dolor{" "}
                </p>
              </div>
            </div>
            <div className="subItem">
              <div className="subItemContent">
                <img src={"./img/Group_689.png"} alt="Group_682.png" />
                <h4>Lorem ipsum</h4>
                <p>
                  Lorem ipsum dolor ngồi amet consectetuer lorem ipsum dolor
                  ngồi amet consectetuer lorem ipsum dolor ngồi amet
                  consectetuer lorem ipsum dolor ngồi amet consectetuer lorem
                  ipsum dolor{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioIcon;
